import React from "react";
import { Link } from "react-router-dom";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import { ContentCoaches } from "./CoachesHome.styled";
import CoachesHomeContainer from "../../containers/CoachesHomeContainer/CoachesHomeContainer";

const CoachesHome = () => {
  return (
    <ContentCoaches>
      <p className="coaches-title">
        <Link to="/MyCoaches">
          Coaches
          <ArrowForward />
        </Link>
      </p>
      <CoachesHomeContainer />
    </ContentCoaches>
  );
};

export default CoachesHome;
